import { AxiosRequestConfig } from 'axios';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IFileResponse from '../../../models/responces/IFileResponse';
import { sendAxiosRequest } from '../../utils/sendRequest';

export interface IApiFileUploadParams {
  file: File;
  cfg?: AxiosRequestConfig;
}

const apiFileUpload = (params: IApiFileUploadParams) => {
  const formData = new FormData();
  formData.append(`File`, params.file);
  const cfg = params.cfg || {};
  return sendAxiosRequest({
    ...cfg,
    method: 'post',
    headers: {
      Authorization: api.getToken(),
      'Content-Type': 'multipart/form-data'
    },
    url: UrlBuilder.getURL({
      handler: 'file'
    }),
    data: formData,
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IFileResponse>;
};

export default apiFileUpload;
